/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

export function AccessRoleEditDialogHeader({ id }) {

    const [title, setTitle] = useState("");
    // Channel Redux state
    const { accessRoleForEdit, actionsLoading } = useSelector(
        (state) => ({
            accessRoleForEdit: state.accessRoles.accessRoleForEdit,
            actionsLoading: state.channels.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        let _title = id ? "" : "Access Role Baru";
        if (accessRoleForEdit && id) {
            _title = "Edit Access Role";
        }

        setTitle(_title);
        // eslint-disable-next-line
    }, [accessRoleForEdit, actionsLoading]);

    return (
        <>
            {actionsLoading && <ModalProgressBar variant="query" />}
            <Modal.Header closeButton>
                <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
            </Modal.Header>
        </>
    );
}
